import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import { actionCreators } from './store';

class Case extends Component {

  componentDidMount() {
    // console.log('props', this.props);
    const { fetchCaseData } = this.props;
    const caseId = this.props.location.pathname.split('/')[2] || this.props.location.state.id;
    fetchCaseData({ id: caseId });
  }

  render() {

    const { caseData } = this.props;

    return (
      <div className="case">
        <div className="case__warp">
          <h2 className="case__title">{ caseData.get('name') }</h2>
          <div className="case__rich-text" dangerouslySetInnerHTML={{ __html: caseData.get('des') }}></div>
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  caseData: state.getIn(['case', 'caseData'])
});

const mapDispatch = (dispatch) => ({
  fetchCaseData(obj) {
    dispatch(actionCreators.fetchCaseData(obj));
  }
});

export default connect(mapState, mapDispatch)(Case);
